import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function useLocationChange(action: (p: string) => void) {
  const location = useLocation();
  const pathname = location.pathname;

  useEffect(() => {
    action(pathname);
  }, [pathname]);
}
